import { SocialMedia } from './models';
import { isEnglish } from '../utils/helper/helpers';
import { mainConfig } from './config.provider';

const getShareAlt = (socialMedia: SocialMedia) => `${isEnglish() ? 'Share via' : 'Teilen über'} ${socialMedia}`;

export interface ShareInfo {
    title?: string;
    text?: string;
    url?: string;
}

export const createShareInfo = (socialMedia: SocialMedia, options?: ShareInfo) => {
    const useCustomText = (value?: string) =>
        options ? `${options.title} ${options.text}:` : value || `${mainConfig.title} ${mainConfig.description}:`;

    switch (socialMedia) {
        case SocialMedia.Facebook:
            return `https://www.facebook.com/sharer.php?u=${mainConfig.url}`;
        case SocialMedia.Mail:
            return `mailto:?subject=${mainConfig.headline}&body=${useCustomText(mainConfig.mailShareText)}%0A${
                mainConfig.url
            }`;
        case SocialMedia.Twitter:
            return `https://twitter.com/intent/tweet?url=${mainConfig.url}&text=${encodeURIComponent(
                useCustomText(mainConfig.twitterShareText)
            )}&via=br24&hashtags=btw21,HieristBayern&related=br_data,br24,br_press
`;
        case SocialMedia.Whatsapp:
            return `whatsapp://send?text=${useCustomText(mainConfig.whatsappShareText)}%0A${mainConfig.url}`;
    }
};

export const SocialMediaMap = {
    [SocialMedia.Facebook]: {
        icon: '\\e803',
        color: '#3b5998',
        alt: getShareAlt(SocialMedia.Facebook),
        link: createShareInfo(SocialMedia.Facebook)
    },
    [SocialMedia.Whatsapp]: {
        icon: '\\f232',
        color: '#4dc247',
        alt: getShareAlt(SocialMedia.Whatsapp),
        link: createShareInfo(SocialMedia.Whatsapp)
    },
    [SocialMedia.Twitter]: {
        icon: '\\e801',
        color: '#4099ff',
        alt: getShareAlt(SocialMedia.Twitter),
        link: createShareInfo(SocialMedia.Twitter)
    },
    [SocialMedia.Mail]: {
        icon: '\\e802',
        color: '#cb2323',
        alt: getShareAlt(SocialMedia.Mail),
        link: createShareInfo(SocialMedia.Mail)
    }
};
